module.exports = __webpack_public_path__ + "static/media/Logo-Homex.0bd2ac16.jpg";